export const URLs = {
    GOOGLE_MAP_API: 'https://maps.googleapis.com/maps/api',
    MAP_BOX_API: 'https://api.mapbox.com',
    MAP_BOX_GEOCODING_API: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
    MAPBOX_GEOCODING_API: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
    MAPBOX_LIGHT_STYLE: 'mapbox://styles/mapbox/light-v11',
    MAPBOX_SATELLITE_STYLE: 'mapbox://styles/mapbox/satellite-streets-v12',
};
